import Link from '@cobliteam/ui/components/Link';
import Popover from '@cobliteam/ui/components/Popover';
import Typography from '@cobliteam/ui/components/Typography';
import appleAppStoreBadge from '../../assets/app-store-badge.svg';
import googlePlayBadge from '../../assets/google-play-badge.svg';

export const AppPopoverContent = () => (
  <div className='w-72 space-y-4'>
    <Typography variant='description-title'>Acesso ao App Cobli Motorista</Typography>
    {/* Clique em <span className={styles.strongText}>Gerar código</span> para que seus motoristas possam acessar o
      aplicativo da Cobli pelo celular. O código é gerado por motorista e, caso ele precise acessar o app novamente, o
      mesmo código pode ser reutilizado. */}
    <Typography variant='body'>O código é gerado por motorista e, caso ele precise acessar o app novamente, o mesmo código pode ser reutilizado.</Typography>
    <div className='flex flex-row justify-evenly'>
      <Link href='https://play.google.com/store/apps/details?id=co.cobli.bolovo' target='_blank' rel='noopener noreferrer'>
        <img src={googlePlayBadge} alt='Google Play' />
      </Link>
      <Link href='https://apps.apple.com/br/app/cobli-motorista/id1503428456' target='_blank' rel='noopener noreferrer'>
        <img src={appleAppStoreBadge} alt='Apple App Store' />
      </Link>
    </div>
  </div>
);

const AppPopover = ({ portal }: { portal?: boolean }) => (
  <Popover>
    <Popover.Trigger>
      <Popover.Icon />
    </Popover.Trigger>
    <Popover.Content portal={portal}>
      <AppPopoverContent />
    </Popover.Content>
  </Popover>
);

export default AppPopover;
